// extracted by mini-css-extract-plugin
module.exports = {"socials":"footer-socials_socials__Dr7Mx","social":"footer-socials_social__MoWmD"};